import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "sonner";

import StickyCTA from "./components/StickyCTA";
import SiteMenu from "./components/SiteMenu";
import Hero from "./components/Hero";
import EditorialMarquee from "./components/EditorialMarquee";
import StatsBar from "./components/StatsBar";
import GallerySlider from "./components/GallerySlider";
import Speakers from "./components/Speakers";
import VideoSection from "./components/VideoSection";
import Workshops from "./components/Workshops";
import Diferenciais from "./components/Diferenciais";
import VenueSection from "./components/VenueSection";
import KitShowcase from "./components/KitShowcase";
import Plans from "./components/Plans";
import Premio from "./components/Premio";
import PremioModal from "./components/PremioModal";
import Faq from "./components/Faq";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import InscriptionModal from "./components/InscriptionModal";
import WhatsAppButton from "./components/WhatsAppButton";
import { SectionDivider } from "./components/Motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Landing = () => {
  const [open, setOpen] = useState(false);
  const [defaultPlan, setDefaultPlan] = useState("presencial");
  const [defaultQty, setDefaultQty] = useState(1);
  const [contextSpeaker, setContextSpeaker] = useState(null);
  const [premioOpen, setPremioOpen] = useState(false);

  // Lenis smooth momentum scrolling
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  // Health ping
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  const openModal = (plan, qty = 1) => {
    if (typeof plan === "string" && (plan === "presencial" || plan === "online")) {
      setDefaultPlan(plan);
    }
    setDefaultQty(qty);
    setContextSpeaker(null);
    setOpen(true);
  };

  const openSpeakerModal = (speaker) => {
    setDefaultPlan("presencial");
    setDefaultQty(1);
    setContextSpeaker(speaker);
    setOpen(true);
  };

  return (
    <div className="App bg-brand-base min-h-screen" data-testid="landing-root">
      <StickyCTA onCTA={() => openModal("presencial")} />
      <SiteMenu />
      <main>
        <Hero onCTA={() => openModal("presencial")} />
        <EditorialMarquee />
        <StatsBar />
        <GallerySlider />
        <VideoSection />
        <Workshops />
        <Speakers onSelect={openSpeakerModal} />
        <Diferenciais />
        <VenueSection />
        <SectionDivider />
        <KitShowcase />
        <SectionDivider />
        <Plans onCTA={openModal} />
        <EditorialMarquee />
        <Premio onInscrever={() => setPremioOpen(true)} />
        <FinalCTA onCTA={() => openModal("presencial")} />
        <SectionDivider />
        <Faq />
      </main>
      <Footer />

      <InscriptionModal
        open={open}
        onOpenChange={setOpen}
        defaultPlan={defaultPlan}
        defaultGroupSize={defaultQty}
        contextSpeaker={contextSpeaker}
      />
      <PremioModal open={premioOpen} onOpenChange={setPremioOpen} />
      <WhatsAppButton />

      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#101C44",
            color: "#fff",
            border: "1px solid rgba(0,142,255,0.30)",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
